import { useState } from "react";
import { api } from "../lib/api";
import { ArrowUp, ArrowDown } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function VoteWidget({ targetType, targetId, initialScore, initialVote = 0, vertical = true, size = "md" }) {
    const { user } = useAuth();
    const [score, setScore] = useState(initialScore || 0);
    const [vote, setVote] = useState(initialVote);

    const cast = async (val) => {
        if (!user) {
            toast.error("Sign in to vote");
            return;
        }
        const newVal = vote === val ? 0 : val;
        try {
            const { data } = await api.post(`/vote/${targetType}/${targetId}`, { value: newVal });
            setScore(data.score);
            setVote(data.user_vote);
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Vote failed");
        }
    };

    const iconSize = size === "sm" ? 14 : 18;
    const wrapClass = vertical ? "flex flex-col items-center gap-0.5" : "flex items-center gap-1";

    return (
        <div className={wrapClass} data-testid={`vote-${targetType}-${targetId}`}>
            <button
                onClick={() => cast(1)}
                className={`p-1 rounded-sm transition-colors inline-flex items-center justify-center min-w-[40px] min-h-[40px] sm:min-w-0 sm:min-h-0 ${vote === 1 ? "text-cyan-400" : "text-slate-500 hover:text-cyan-400"}`}
                data-testid={`upvote-${targetId}`}
                aria-label="Upvote"
            >
                <ArrowUp size={iconSize} weight={vote === 1 ? "fill" : "bold"} />
            </button>
            <span className={`text-xs font-bold ${vote === 1 ? "text-cyan-400" : vote === -1 ? "text-rose-400" : "text-slate-300"}`} data-testid={`score-${targetId}`}>
                {score}
            </span>
            <button
                onClick={() => cast(-1)}
                className={`p-1 rounded-sm transition-colors inline-flex items-center justify-center min-w-[40px] min-h-[40px] sm:min-w-0 sm:min-h-0 ${vote === -1 ? "text-rose-400" : "text-slate-500 hover:text-rose-400"}`}
                data-testid={`downvote-${targetId}`}
                aria-label="Downvote"
            >
                <ArrowDown size={iconSize} weight={vote === -1 ? "fill" : "bold"} />
            </button>
        </div>
    );
}
